export const mainPath = ''
export const bePath='https://crmbe.focusmarketing.tech'